//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FilesService from '@/apps/data-platform/services/security/files_service';
export default {
  name: 'TabViewsView',
  data: function data() {
    return {
      inputSearch: '',
      filter: '',
      fields: [{
        key: 'name',
        label: 'Name',
        class: 'w-10'
      }, {
        key: 'owner_name',
        label: 'Owner',
        class: 'w-15'
      }, {
        key: 'sheettype',
        label: 'Sheet type',
        class: 'w-20'
      }, {
        key: 'title',
        label: 'Title',
        class: 'w-30'
      }, {
        key: 'caption',
        label: 'Caption',
        class: 'w-30'
      }, {
        key: 'preview_image',
        label: 'Preview',
        class: 'w-5 text-center'
      }],
      currentView: {},
      currentImage: {}
    };
  },
  props: {
    item: {
      type: Object,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    isChangeRequest: {
      type: String,
      default: ''
    }
  },
  created: function created() {
    console.log("dbug:", this.item);
  },
  computed: {
    headers: function headers() {
      return [{
        value: 'name',
        text: this.traductor('my_tasks.tablas_tasks.name'),
        class: 'w-10'
      }, {
        value: 'owner_name',
        text: this.traductor('my_tasks.tablas_tasks.owner'),
        class: 'w-15'
      }, {
        value: 'sheettype',
        text: this.traductor('my_tasks.tablas_tasks.sheet_type'),
        class: 'w-20'
      }, {
        value: 'title',
        text: this.traductor('my_tasks.tablas_tasks.title'),
        class: 'w-30'
      }, {
        value: 'caption',
        text: this.traductor('my_tasks.tablas_tasks.caption'),
        class: 'w-30'
      }, {
        value: 'preview_image',
        text: this.traductor('my_tasks.tablas_tasks.preview'),
        class: 'w-5 text-center'
      }];
    }
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    showModal: function showModal(view) {
      var _this = this;
      this.currentView = view;
      FilesService.readFile(view.preview_image).then(function (response) {
        _this.currentImage = response.data;
      }).then(function () {
        _this.$refs['modal-preview-image'].show();
      });
    }
  }
};